<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/admin/home">
        <img
          class="navbar-brand-full ml-2"
          src="img/logo-CDLQGVN.png"
          width="auto"
          height="90%"
          alt="Logo"
        />
        <img
          class="navbar-brand-minimized ml-2"
          src="img/logo5.png"
          width="auto"
          height="80%"
          alt="Logo"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none hidden" display="lg" />
      <!-- <SidebarMinimizer class="d-md-down-none" display="lg" /> -->
      <!-- <b-navbar-nav class="d-md-down-none">
            <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
            <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
            <b-nav-item class="px-3">Settings</b-nav-item>
          </b-navbar-nav>-->
      <b-navbar-nav class="ml-auto">
        <!-- list icon -->
        <!-- <b-nav-item class="d-md-down-none">
              <i class="icon-bell icons"></i>
              <b-badge pill variant="danger">5</b-badge>
            </b-nav-item>-->
        <!-- <b-nav-item class="d-md-down-none">
              <i class="icon-list"></i>
            </b-nav-item>
            <b-nav-item class="d-md-down-none">
              <i class="icon-location-pin"></i>
            </b-nav-item>-->

        <!-- account -->
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>

      <!-- menu right -->
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!-- <AsideToggler class="d-lg-none" mobile /> -->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav class="sidebar_nav" :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <!-- <Breadcrumb :list="list"/> -->
        <div
          class="phone-icon"
          v-if="
            currentUser.roles.includes('SafePlace') ||
            currentUser.roles.includes('TourAgent')
          "
        >
          <PhoneIcon></PhoneIcon>
        </div>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <!-- <DefaultAside /> -->
      </AppAside>
    </div>

    <!--footer-->
    <TheFooter>
      <div class="text-center footer" style="width: 100%">
        <h5
          style="
            color: white;
            margin-bottom: 0px;
            font-family: 'Times New Roman';
            font-weight: bold;
          "
        >
          {{ aLang.default_container_footer_header }}
        </h5>
        <p style="color: white; font-family: 'Times New Roman'; margin: 0">
          {{ aLang.default_container_footer_phone_number }}:
          <a style="color: #ffffff" href="tel:19006888">1900 6888</a>; Email:
          <a style="color: #ffffff" href="mailto:info@vietsens.vn"
            >info@vietsens.vn</a
          >;
        </p>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import MethodService from "../service/MethodService";
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import PhoneIcon from "@/component/PhoneIcon";
import PhanHoiApi from "../moduleApi/PhanHoiApi";
import DiemDenAnToanApi from "@/moduleApi/DiemDenAnToanApi";
import LanguageService from "../service/LanguageService";
import CommuneApi from "../moduleApi/CommuneApi";

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    PhoneIcon,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      nav: [],
      currentUser: JSON.parse(localStorage.getItem("currentUser")),
      navNew: [],
      prevUrl: null,
    };
  },

  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
  },
  methods: {
    async fn_checkCapNhatDonViHanhChinh() {
      const userAccount = this.currentUser.account;

      const res = await DiemDenAnToanApi.list({
        filters: `du_lieu_khai_bao.user_account=${userAccount}`,
        limit: 1,
      });

      if (!res.result || res.result.length === 0) return;

      const diemDen = res.result[0];
      const xaId = diemDen.du_lieu_khai_bao.dia_chi_xa_id;

      let shouldUpdate = false;

      if (!xaId) {
        shouldUpdate = true;
      } else {
        const resCommune = await CommuneApi.findById(xaId);
        if (resCommune.result.disabled) {
          shouldUpdate = true;
        }
      }

      if (shouldUpdate) {
        this.$confirm(
          "Từ ngày 01/07/2025, theo nghị quyết về sắp xếp đơn vị hành chính cấp xã của Quốc hội, địa chỉ (Phường/Xã) của bạn có sự thay đổi. Xin vui lòng cập nhật lại thông tin địa giới hành chính mới.",
          {
            confirmButtonText: "Cập nhật",
            cancelButtonText: "Để sau",
            type: "info",
          }
        ).then(() => {
          this.$router.push({
            name: "Admin-DangKyDDAT-update",
            params: { id: diemDen.id },
          });
        });
      }
    },
    async fn_countPhanHoi() {
      let currentUser = MethodService.getCurrentUser();
      let res = await PhanHoiApi.countNew(currentUser.id);
      $.each(this.nav, (index, item) => {
        if (item.code == "PhanHoi") {
          item.badge.text = res.meta.total;
        }
      });
    },

    fn_recountPhanHoi() {
      window.reqIntervalPhanHoi = setInterval(() => {
        this.fn_countPhanHoi();
      }, 900000); //15phut
    },

    async fn_getNav() {
      let currentUser = MethodService.getCurrentUser();
      let arrNav = MethodService.copyObject(nav.items);

      $.each(arrNav, (indexNar1, valueNarLever1) => {
        if (
          valueNarLever1.meta.allowAccess &&
          valueNarLever1.meta.allowAccess.length > 0
        ) {
          //check quyền truy cập Nav1
          $.each(
            valueNarLever1.meta.allowAccess,
            (indexMeta1, valueMetaLever1) => {
              if (
                currentUser.roles.indexOf(valueMetaLever1) != -1 ||
                valueMetaLever1 == "*"
              ) {
                valueNarLever1.meta.allow = true;
              }
            }
          );
          //check xem tồn tại Nav2
          if (valueNarLever1.children && valueNarLever1.children.length > 0) {
            $.each(valueNarLever1.children, (indexNar2, valueNarLever2) => {
              if (
                valueNarLever2.meta.allowAccess &&
                valueNarLever2.meta.allowAccess.length > 0
              ) {
                //check quyền truy cập Nav2
                $.each(
                  valueNarLever2.meta.allowAccess,
                  (indexMeta2, valueMetaLever2) => {
                    if (
                      currentUser.roles.indexOf(valueMetaLever2) != -1 ||
                      valueMetaLever2 == "*"
                    ) {
                      valueNarLever2.meta.allow = true;
                    }
                  }
                );
                //check xem tồn tại Nav3
                if (
                  valueNarLever2.children &&
                  valueNarLever2.children.length > 0
                ) {
                  $.each(
                    valueNarLever2.children,
                    (indexNar3, valueNarLever3) => {
                      if (
                        valueNarLever3.meta.allowAccess &&
                        valueNarLever3.meta.allowAccess.length > 0
                      ) {
                        //check quyền truy cập Nav3
                        $.each(
                          valueNarLever3.meta.allowAccess,
                          (indexMeta3, valueMetaLever3) => {
                            if (
                              currentUser.roles.indexOf(valueMetaLever3) !=
                                -1 ||
                              valueMetaLever3 == "*"
                            ) {
                              valueNarLever3.meta.allow = true;
                            }
                          }
                        );
                        //Mở rộng thêm ở đây
                      }
                    }
                  );
                }
              }
            });
          }
        }
      });
      //Check Lọc quyền Nav1 và trả về mảng đã lọc arrNavFilter
      let arrNavFilter = arrNav.filter(function (value, index, arr) {
        return value.meta.allow == true;
      });
      $.each(arrNavFilter, function (indexNavF1, valueNavF1) {
        //check tồn tại Nav2
        if (valueNavF1.children && valueNavF1.children.length > 0) {
          // Lọc quyền Nav2 và trả về mảng đã lọc arrNavFilter2
          let arrNavFilter2 = valueNavF1.children.filter(function (
            value2,
            index2,
            arr2
          ) {
            return value2.meta.allow == true;
          });
          //gán mảng Nav2 đã lọc vào mảng mẹ
          valueNavF1.children = arrNavFilter2;
          $.each(arrNavFilter2.children, function (indexNavF12, valueNavF2) {
            //check tồn tại Nav3
            if (valueNavF2.children && valueNavF2.children.length > 0) {
              // Lọc quyền Nav3 và trả về mảng đã lọc arrNavFilter3
              var arrNavFilter3 = valueNavF2.children.filter(function (
                value3,
                index3,
                arr3
              ) {
                return value3.meta.allow == true;
              });
              //gán mảng Nav3 đã lọc vào mảng mẹ
              valueNavF2.children = arrNavFilter3;
              // Mở rộng tiếp theo ở đây
            }
          });
        }
      });
      // loc theo da co don cc hya chua\
      if (currentUser.roles.includes("SafePlace")) {
        const URLSafePlaceInActive = [
          "/admin/DangKyDDAT/list",
          "/admin/DanhGiaDDATHangNgay/daily",
          "/admin/CheckinDDAT/list",
        ];
        const URLSafePlaceWithoutTypeOfStay = [
          "/admin/DanhGiaDDATHangNgay/daily",
        ];
        const diemDenAnToanRes = await DiemDenAnToanApi.list({
          filters: "nguoi_tao_id=" + this.currentUser.id,
        });
        if (diemDenAnToanRes.result) {
          if (
            diemDenAnToanRes.result[0].hoat_dong &&
            diemDenAnToanRes.result[0].hoat_dong.ngung_hoat_dong
          ) {
            if (diemDenAnToanRes.result[0].hoat_dong.ngung_hoat_dong == true) {
              const arrNavFilter4 = arrNavFilter.filter(
                (x) => URLSafePlaceInActive.includes(x.url) == false
              );
              arrNavFilter = arrNavFilter4;
            }
          }
          if (
            !"hotel,tourist_villa,tourist_apartment,tourist_cruise,motel,homestay".includes(
              diemDenAnToanRes.result[0].loai_diem_den
            )
          ) {
            const arrNavFilter4 = arrNavFilter.filter(
              (x) => URLSafePlaceWithoutTypeOfStay.includes(x.url) == false
            );
            arrNavFilter = arrNavFilter4;
          }
        }
      }

      // Gán mảng mẹ vào Nav Main
      this.nav = arrNavFilter;
    },
  },
  created() {
    // let a = document.querySelectorAll(".badge");
    // a.forEach(item => {
    //     if(item.innerHTML == "0"){
    //         item.classList.add("hide");
    //     }
    //     console.log("item",item);
    // })
    //active route
    if (this.$router.currentRoute.path.indexOf("/admin/DanhGia/") !== -1) {
      this.prevUrl = localStorage.getItem("prevUrl");
      this.nav = this.nav.map((item) => {
        if (item.url == this.prevUrl) {
          item.class = "activeClassRoute";
          return item;
        } else {
          item.class = null;
          return item;
        }
      });
    } else {
      this.nav = this.nav.map((item) => {
        item.class = null;
        return item;
      });
    }
    //end active route
    this.fn_getNav();

    if (
      MethodService.checkRole("Admin, Officer, TourAgent, TCQLTT, VNATAdmin, SVHTT")
    ) {
      this.fn_countPhanHoi();
      this.fn_recountPhanHoi();
    }
    if (MethodService.checkRole("SafePlace")) {
      this.fn_checkCapNhatDonViHanhChinh();
    }

    //xu li active
  },
  mouted() {},
  beforeUpdate(to, from, next) {
    //active route

    if (this.$router.currentRoute.path.indexOf("/admin/DanhGia/") !== -1) {
      this.prevUrl = localStorage.getItem("prevUrl");
      this.nav = this.nav.map((item) => {
        if (item.url == this.prevUrl) {
          item.class = "activeClassRoute";
          return item;
        } else {
          item.class = null;
          return item;
        }
      });
    } else {
      this.nav = this.nav.map((item) => {
        item.class = null;
        return item;
      });
    }
    //End active route
  },
  watch: {
    "$store.state.phanHoi.refreshFnCountNew": function (newVal, oldVal) {
      var _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countPhanHoi();
      }
    },
    $route(to, from) {
      // console.log('{{{{ to }}}}',to);
      //  console.log('{{{{ from }}}}',from);
      //  if(from.path=='/admin/DanhGiaKDL/list'&& to.path=="/admin/DanhGia/list"){
      //      _this.nav.map(item=>item.class="active")
      //  }
      // debugger
    },
  },
};
</script>

<style scoped>
/*Fixes double tap on iOS*/
.phone-icon {
  position: fixed;
  bottom: 55px;
  right: 10px;
  z-index: 999999;
}
@media (max-width: 768px) {
  .phone-icon {
    position: fixed;
    bottom: 45px;
    right: 5px;
    z-index: 999999;
  }
}
.el-scrollbar__bar {
  opacity: 1 !important;
}
.activeClassRoute {
  color: #fff !important;
  background: #293846;
  border-left: 4px solid #19aa8d;
}

::v-deep .app-footer {
  margin-left: 0 !important;
  padding: 0 !important;
  background-image: url("~/img/footer.jpg");
  position: sticky;
  bottom: 0;
  z-index: 10;
}
::v-deep .nav-link {
  display: flex;
  align-items: center;
  position: relative;
}
::v-deep .badge.badge-danger {
  position: absolute;
  right: 10px;
}
.hide {
  display: none;
}
@media (min-width: 992px) {
  ::v-deep .app-body .sidebar {
    height: calc(100vh - 96px) !important;
  }
}

@media (max-width: 991.98px) {
  ::v-deep .app-footer {
    position: relative;
  }
  ::v-deep .sidebar {
    position: fixed;
    z-index: 1019;
    width: 230px;
    height: calc(100vh - 96px);
  }
}

@media (max-width: 767px) {
  ::v-deep .sidebar {
    position: fixed;
    z-index: 1019;
    width: 230px;
    height: calc(100vh - 46px);
  }
  .footer h5 {
    font-size: 14px;
  }

  .footer p {
    font-size: 12px !important;
  }
}
</style>
